import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const MisFacturas = ({ empresa }) => {
	const [facturas, setFacturas] = useState([]);
	const [pagination, setPagination] = useState(null);
	const [error, setError] = useState('');
	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const [form, setForm] = useState({
		cif: '',
		nombre: '',
		nombre_razon: '',
		nombre_representante: '',
		nif_representante: '',
	});

	/* ---------- Obtener configuración Verifactu ---------- */
	const verifactu = (() => {
		try {
			const notas = JSON.parse(empresa?.notasEmpresa || '{}');
			return notas.verifactu || null;
		} catch {
			return null;
		}
	})();

	const configuracionIncompleta =
		!verifactu?.cif || !verifactu?.nombre || !verifactu?.nombre_razon;

	/* ---------- Guardar config en notasEmpresa ---------- */
	const guardarConfigVerifactu = async () => {
		if (!form.cif || !form.nombre || !form.nombre_razon) {
			setError('CIF, nombre y nombre razón son obligatorios');
			return;
		}

		setLoading(true);
		setError('');

		const nuevaConfig = {
			verifactu: {
				...form,
				apiBaseUrl: 'https://facturas-service.cedesa.es',
				apiKey: verifactu?.apiKey || '',
			},
		};

		try {
			/* 1️⃣ Crear empresa en Verifactu */
			await axios.post(
				'https://facturas-service.cedesa.es/api/v1/crear-empresa',
				{
					nombre: form.nombre,
					cif: form.cif,
					nombre_razon: form.nombre_razon,
					nombre_representante: form.nombre_representante,
					nif_representante: form.nif_representante,
				},
				{
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-Key': process.env.REACT_APP_VERIFACTU_API_KEY,
                        },
				}
			);

			/* 2️⃣ Guardar en notasEmpresa (solo frontend) */
			empresa.notasEmpresa = JSON.stringify(nuevaConfig, null, 2);

			/* 3️⃣ Cargar facturas */
			getFacturas(1);
		} catch (err) {
            console.error('Error registrando empresa:', err.response || err.message || err);
            setError(
                err.response?.data?.message ||
                err.message ||
                'Error al registrar la empresa en Verifactu'
            );
            }
	};

	/* ---------- Listar facturas ---------- */
	const getFacturas = (pageNumber = 1) => {
		if (configuracionIncompleta) return;

		axios
			.get(`${verifactu.apiBaseUrl}/api/v1/listar-facturas`, {
				headers: verifactu.apiKey
					? { Authorization: `Bearer ${verifactu.apiKey}` }
					: {},
				params: {
					cif: verifactu.cif,
					page: pageNumber,
					per_page: 15,
				},
			})
			.then((res) => {
				setFacturas(res.data.data);
				setPagination(res.data.pagination);
				setPage(pageNumber);
			})
			.catch(() => setError('Error al consultar facturas'));
	};

	useEffect(() => {
		if (!configuracionIncompleta) {
			getFacturas(1);
		}
	}, [empresa]);

	/* ---------- FORMULARIO ---------- */
if (configuracionIncompleta) {
  return (
    <div className="flex justify-center mt-12 px-4">
      <div className="w-full max-w-lg bg-white p-6 rounded-lg shadow-lg">
        <h3 className="text-2xl font-semibold mb-6 text-center">Configurar Verifactu</h3>

        {error && (
          <div className="bg-red-100 text-red-700 p-3 rounded mb-4">{error}</div>
        )}

        <div className="space-y-4">
          <input
            type="text"
            placeholder="CIF *"
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={form.cif}
            onChange={(e) => setForm({ ...form, cif: e.target.value })}
          />

          <input
            type="text"
            placeholder="Nombre empresa *"
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={form.nombre}
            onChange={(e) => setForm({ ...form, nombre: e.target.value })}
          />

          <input
            type="text"
            placeholder="Nombre razón social *"
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={form.nombre_razon}
            onChange={(e) => setForm({ ...form, nombre_razon: e.target.value })}
          />

          <input
            type="text"
            placeholder="Nombre representante"
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={form.nombre_representante}
            onChange={(e) => setForm({ ...form, nombre_representante: e.target.value })}
          />

          <input
            type="text"
            placeholder="CIF/NIF representante"
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={form.nif_representante}
            onChange={(e) => setForm({ ...form, nif_representante: e.target.value })}
          />
        </div>

        <button
          onClick={guardarConfigVerifactu}
          disabled={loading}
          className={`mt-6 w-full py-2 rounded text-white ${
            loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
          }`}
        >
          {loading ? 'Guardando...' : 'Aceptar'}
        </button>
      </div>
    </div>
  );
}

	/* ---------- LISTADO ---------- */
	return (
  	<div className="misFacturas max-w-5xl mx-auto mt-12 px-4">
    {/* ---------- TITULO ---------- */}
    <h2 className="text-2xl font-bold mb-4 text-gray-800">Mis Facturas</h2>

    {/* ---------- TABLA DE FACTURAS ---------- */}
    <table className="table-auto w-full border-collapse border border-gray-300 mb-6 shadow-md">
      <thead>
        <tr className="bg-blue-100">
          <th className="border border-gray-300 px-3 py-2">Número</th>
          <th className="border border-gray-300 px-3 py-2">Fecha</th>
          <th className="border border-gray-300 px-3 py-2">Total</th>
          <th className="border border-gray-300 px-3 py-2">Estado</th>
        </tr>
      </thead>
      <tbody>
        {facturas.map((f) => (
          <tr key={f.id} className="hover:bg-blue-50">
            <td className="border border-gray-300 px-3 py-2">{f.numero}</td>
            <td className="border border-gray-300 px-3 py-2">{f.fecha}</td>
            <td className="border border-gray-300 px-3 py-2">{f.total.toFixed(2)} €</td>
            <td className="border border-gray-300 px-3 py-2">{f.estadoEnvio?.descripcion}</td>
          </tr>
        ))}
      </tbody>
    </table>

    {pagination && (
      <div className="flex justify-between items-center">
        <button
          disabled={page === 1}
          onClick={() => getFacturas(page - 1)}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Anterior
        </button>
        <span>
          Página {pagination.current_page} de {pagination.last_page}
        </span>
        <button
          disabled={page === pagination.last_page}
          onClick={() => getFacturas(page + 1)}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Siguiente
        </button>
      </div>
    )}
  </div>
);
};
